export default class ApiOviewDocmd {
    static async Docmd(cmd, postData, successCallback, errorCallback) {
        let url = window.gMainMap.MakeDoCmdUrl(cmd);
        try {
            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify(postData)
            });
            const json = await response.json();
            if (json.success) {
                successCallback(json);
            }
            else {
                errorCallback(json);
            }

        } catch (error) {
            console.log("error:", error);
        }
    }  
}
